// extracted by mini-css-extract-plugin
export var outcomeIcon = "OutcomeIcon-module--outcomeIcon--990e6";
export var silkSpacing = "OutcomeIcon-module--silkSpacing--7c5bb";